import { api } from '../lib/api';
import { API_URL } from '../lib/config';

export async function renderLanding(container: HTMLElement): Promise<void> {
  // Check if user is already logged in
  const user = await api.getCurrentUser();
  if (user) {
    window.location.href = '/dashboard';
    return;
  }

  container.innerHTML = `
    <div class="landing">
      <div class="landing-content">
        <h1>CrowdCam</h1>
        <p class="subtitle">Create events and let your audience stream to you</p>

        <div class="features">
          <div class="feature">
            <span class="icon">📹</span>
            <h3>Create Events</h3>
            <p>Set up a streaming event in seconds</p>
          </div>
          <div class="feature">
            <span class="icon">📱</span>
            <h3>Share QR Code</h3>
            <p>Participants scan to join instantly</p>
          </div>
          <div class="feature">
            <span class="icon">🖥️</span>
            <h3>Watch Live</h3>
            <p>View all streams in a beautiful grid</p>
          </div>
        </div>

        <button class="primary login-btn" id="login-btn">
          Sign in with Google
        </button>
      </div>
    </div>

    <style>
      .landing {
        min-height: 100vh;
        display: flex;
        align-items: center;
        justify-content: center;
        padding: 2rem;
      }

      .landing-content {
        text-align: center;
        max-width: 600px;
      }

      .landing h1 {
        font-size: 3rem;
        font-weight: 700;
        margin-bottom: 0.5rem;
        background: linear-gradient(135deg, var(--color-primary), #8b5cf6);
        -webkit-background-clip: text;
        -webkit-text-fill-color: transparent;
        background-clip: text;
      }

      .subtitle {
        font-size: 1.25rem;
        color: var(--color-text-muted);
        margin-bottom: 3rem;
      }

      .features {
        display: grid;
        grid-template-columns: repeat(3, 1fr);
        gap: 1.5rem;
        margin-bottom: 3rem;
      }

      @media (max-width: 640px) {
        .features {
          grid-template-columns: 1fr;
        }
      }

      .feature {
        padding: 1.5rem;
        background: var(--color-surface);
        border-radius: var(--radius-lg);
        border: 1px solid var(--color-border);
      }

      .feature .icon {
        font-size: 2rem;
        display: block;
        margin-bottom: 0.5rem;
      }

      .feature h3 {
        font-size: 1rem;
        margin-bottom: 0.25rem;
      }

      .feature p {
        font-size: 0.875rem;
        color: var(--color-text-muted);
      }

      .login-btn {
        font-size: 1.125rem;
        padding: 1rem 2rem;
      }
    </style>
  `;

  document.getElementById('login-btn')?.addEventListener('click', () => {
    window.location.href = `${API_URL}/auth/google`;
  });
}
